import { isWeb, styled } from "@tamagui/core";
import { TextInputComponent } from "./TextInputComponent.mjs";
const StyledTextInput = styled(TextInputComponent, {
  animateOnly: [
  // Keys need to be duplicated to work on web & mobile
  "background-color", "border-color", "box-shadow", "backgroundColor", "borderColor"],
  backgroundColor: "$textInput.background",
  borderRadius: "$textInput",
  borderWidth: "$textInput.borderWidth",
  color: "$text-primary",
  defaultVariants: {
    isDisabled: !1,
    state: "default"
  },
  ...(isWeb ? {
    tabIndex: 0
  } : {
    focusable: !0
  }),
  animation: "textInput",
  disabledStyle: {
    backgroundColor: "$textInput.background.disabled",
    borderColor: "$textInput.border.disabled"
  },
  focusVisibleStyle: {
    outlineWidth: 0
  },
  fontFamily: "$body",
  fontSize: "$regular",
  fontWeight: "400",
  height: "$textInput.height",
  name: "SunshineTextInput",
  outlineWidth: 0,
  overflow: "visible",
  paddingHorizontal: "$textInput.horizontalPadding",
  placeholderTextColor: "$text-discreet",
  variants: {
    isDisabled: {
      true: {
        disabled: !0
      }
    },
    state: {
      default: {
        borderColor: "$textInput.border.default",
        focusStyle: {
          borderColor: "$textInput.border.default.focus"
        },
        hoverStyle: {
          borderColor: "$textInput.border.default.hover"
        }
      },
      error: {
        borderColor: "$textInput.border.error",
        focusStyle: {
          borderColor: "$textInput.border.error"
        },
        hoverStyle: {
          borderColor: "$textInput.border.error"
        }
      }
    }
  },
  // @ts-expect-error type says it's not existing but it's forwarded in reality.
  whiteSpace: "pre-wrap"
}, {
  accept: {
    placeholderTextColor: "color"
  },
  isInput: !0
});
export { StyledTextInput };
//# sourceMappingURL=TextInput.shared.mjs.map
